import { dateUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { useHook } from '../../../lenteHooks'
import { OverviewItem } from '../../overview/OverviewItem'

export const CommitmentStart = () => {
  const translate = useTranslate()
  const { ownerId, tenantId } = useHook('routing.general.useEntityParams')()
  const { data: commitmentVersion } = useHook(
    'fetchers.life.useFetchCommitmentVersionLatest',
  )({
    ownerId,
    tenantId,
  })

  return (
    <OverviewItem iconName="Clock">
      {translate('commitmentStart.startDate', {
        startDate: dateUtils.dateAsStr(commitmentVersion?.fromDate),
      })}
    </OverviewItem>
  )
}
